export default __webpack_public_path__ + "2a18ec7d37460bb5d1f5edcd53dece10.jpg";